import React from 'react'
import {Controller} from 'react-hook-form'
import {DatePicker} from '@mui/x-date-pickers/DatePicker'
import useMediaQuery from '@mui/material/useMediaQuery'
import dayjs, {Dayjs} from 'dayjs'
import 'dayjs/locale/ru'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import {FormInputProps} from '../../../types/formInputProps'

dayjs.extend(customParseFormat)
dayjs.locale('ru')

const FormInputDate = ({name, control, label, sx, defaultValue}: FormInputProps) => {
  const isDesktop = useMediaQuery('@media (pointer: fine)', { defaultMatches: true })

  const parseDate = (val: any): Dayjs | null => {
    if (!val) return null
    if (dayjs.isDayjs(val)) return val.isValid() ? val : null
    if (val instanceof Date) return dayjs(val).isValid() ? dayjs(val) : null
    if (typeof val === 'string') {
      const trimmed = val.trim()
      if (!trimmed || trimmed === '0000-00-00') return null
      if (trimmed.includes('.')) {
        const d = dayjs(trimmed, 'DD.MM.YYYY')
        return d.isValid() ? d : null
      }
      const d = dayjs(trimmed, 'YYYY-MM-DD')
      return d.isValid() ? d : (dayjs(trimmed).isValid() ? dayjs(trimmed) : null)
    }
    return null
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? ''}
      render={({field}) => {
        return (
          <DatePicker
            label={label}
            value={parseDate(field.value)}
            onChange={(newValue: Dayjs | null) => {
              if (newValue && newValue.isValid()) {
                field.onChange(newValue.format('YYYY-MM-DD'))
              } else {
                field.onChange('')
              }
            }}
            format="DD.MM.YYYY"
            slotProps={{
              textField: {
                size: 'small',
                fullWidth: !sx?.width,
                sx: {
                  bgcolor: '#ffffff',
                  ...sx,
                  '& .clearButton': {
                    opacity: 1,
                  },
                },
                placeholder: 'ДД.ММ.ГГГГ',
                inputProps: !isDesktop ? { readOnly: true } : undefined,
              },
              field: {
                clearable: true,
                readOnly: false,
                onClear: (e: React.MouseEvent) => {
                  e.stopPropagation()
                },
              },
              actionBar: {
                actions: ['clear', 'cancel', 'accept'],
              },
            }}
          />
        )
      }}
    />
  )
}

export default FormInputDate
